export const isDevelopment = process.env.NODE_ENV === "development";
export const getApiUrl = () => {
    // Debug environment variables in development
    // if (isDevelopment) {
    //   console.log('🔧 Development mode - API URL resolution:');
    //   console.log('NODE_ENV:', process.env.NODE_ENV);
    //   console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    // }
    // Use environment variable if available (for development)
    if (process.env.REACT_APP_API_URL) {
        if (isDevelopment) {
            console.log('Using REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
        }
        return process.env.REACT_APP_API_URL;
    }
    // Fallback to domain-based routing for production
    switch (window.location.host.toLowerCase()) {
        case 'ptn.morganruraltech.com.au':
            return 'https://ptn.api.morganruraltech.com.au/api/v1/';
        case 'ptntool.mla.com.au':
            return 'https://ptntoolapi.mla.com.au/api/v1/';
        default:
            // Development default - Docker instance
            const fallbackUrl = 'http://localhost:8060/api/v1/';
            if (isDevelopment) {
                console.log('Using fallback URL:', fallbackUrl);
            }
            return fallbackUrl;
    }
};
